export const SEARCH_RESULT_NEWS_LIMIT = 15;
export const LATESTNEWS_RESULT_NEWS_LIMIT = 15;
/** Latest News page sidebar: first N = Don't Miss It, next N = Recommended (same order as main list). */
export const DONT_MISS_IT_LATEST_SLICE_LIMIT = 3;
export const SUBCATEGORY_PAGE_NEWS_LIMIT = 15;
export const TAG_PAGE_RESULT_LIMIT = 15;
export const QUOTE_PAGE_RESULT_LIMIT = 15;
export const INTERVIEWS_PAGE_RESULT_LIMIT = 15;
export const VISUAL_STORY_PAGE_LIMIT = 15;
export const SHORTS_PAGE_LIMIT = 15;
export const PHOTO_STORY_PAGE_LIMIT = 15;
export const MAX_COPY_TEXT_LENGTH = 100;
export const MAX_ITEMS_PER_SITEMPAP = 1000;
export const PHOTOGRAPHER_PAGE_RESULT_LIMIT = 11;
export const SINGLE_EDITION_EPAPERS_LIMIT = 10;

export const TWITTER_USERNAME = "@online_dbi";
export const YOUTUBE_USERNAME = "@online_dbi";
export const FACEBOOK_USERNAME = "@online_dbi";
export const CONTACT_EMAIL = "test@gmail.com";
export const WEBSITE_NAME = "Prajasakti";

/** Black logo for light backgrounds. */
export const SITE_LOGO_BLACK_SRC = "/logo-black.svg";

/** White logo for dark backgrounds. */
export const SITE_LOGO_WHITE_SRC = "/logo-white.svg";

/** Default logo on light surfaces (auth, etc.). */
export const SITE_LOGO_SRC = SITE_LOGO_BLACK_SRC;

/** E-paper header — same SVG set as main site. */
export const EPAPER_LOGO_SRC = SITE_LOGO_BLACK_SRC;

// All URLs are strictly env-driven – no hardcoded domains.
// Use empty string when env is missing so builds don't crash; this still
// ensures values only ever come from env variables.
export const WEBSITE_URL = process.env.NEXT_PUBLIC_CLIENT_URL ?? "";

/** Intrinsic dimensions for header logos (matches lg rendered size). */
export const HEADER_LOGO_WIDTH = 260;
export const HEADER_LOGO_HEIGHT = 80;

/** Main site header logo (see globals.css `.site-header-logo`). */
export const HEADER_LOGO_CLASS = "site-header-logo";

/** E-paper layout header logo (see globals.css `.site-header-logo--epaper`). */
export const EPAPER_HEADER_LOGO_CLASS = "site-header-logo--epaper";

/** Sans-serif stack for English masthead text (E-PAPER label, header dates). */
export const EPAPER_MASTHEAD_ENGLISH_FONT_CLASS = "font-sans";

/** Hamburger / search overlay logo (see globals.css `.site-header-logo--modal`). */
export const HEADER_LOGO_MODAL_CLASS = "site-header-logo--modal";

/** Blue E-PAPER pill — main header and e-paper masthead. */
export const HEADER_EPAPER_BADGE_CLASS =
  "inline-flex shrink-0 items-center justify-center rounded-full bg-primaryColor px-2.5 py-1 text-xs font-[700] uppercase tracking-wide text-white sm:px-3 sm:py-1.5 sm:text-sm lg:px-3.5 lg:py-1.5 lg:text-base";

// Read env vars via globalThis to avoid depending on Node types during build
const runtimeEnv = (globalThis as any)?.process?.env ?? {};

// Strip trailing /api or /api/ from the public API URL to get the base backend URL.
const rawApiUrl = process.env.NEXT_PUBLIC_API_URL ?? "";
export const BACKEND_URL = rawApiUrl.replace(/\/api\/?$/, "");

// Prefer dedicated image store env; fall back to generic file base URL env.
export const IMAGE_URL =
  (process.env.NEXT_PUBLIC_IMG_STORE_URL as string) ||
  (process.env.NEXT_PUBLIC_FILE_BASE_URL as string);

export const META_TITLE =
  "prajasakti: Latest News | Recent News | prajasakti News | Breaking News";
export const META_DESCRIPTION =
  "News from prajasakti. Recent News, Breaking news in India, Brings You Latest News, Political News, Weather, Sports, Entertainment, LifeStyle. The Left Latest News Include News Today, News Latest, News in Telugu, Telugu News, Telungu news";
export const META_KEYWORDS = [
  "Latest News, Recent News, News Updates, News Latest, News Today, Telugu, Telung",
];

export const DEFAULT_LANGUAGE = "te";
